import {
	Card,
	CardHeader,
	CardBody,
	ExternalLink,
} from '@wordpress/components';

import { __ } from '@wordpress/i18n';

export default function Help() {
	return (
		<>
			<Card>
				<CardHeader>
					<b>{ __( 'Need help?', 'popper' ) }</b>
				</CardHeader>

				<CardBody>
					<p>
						{ __(
							'Detailed documentation is available on the plugin website.',
							'popper'
						) }
					</p>

					<ExternalLink href="https://popperwp.com/docs">
						{ __( 'Documentation', 'popper' ) }
					</ExternalLink>
					<p>
						{ __(
							'We would love to help you out if you need any help.',
							'popper'
						) }
					</p>

					<ExternalLink href="https://wordpress.org/support/plugin/popper/">
						{ __( 'Ask a question', 'popper' ) }
					</ExternalLink>
				</CardBody>
			</Card>
			<Card className="ads-container__reviews">
				<CardHeader>
					<b>{ __( 'Do you like the plugin?', 'popper' ) }</b>
				</CardHeader>

				<CardBody>
					<p>
						{ __(
							'If you like Popper plugin you can share a review to help us and spread some love!',
							'popper'
						) }
					</p>
					<ExternalLink href="https://wordpress.org/support/plugin/popper/reviews/#new-post">
						{ __( 'Rate 5 stars!', 'popper' ) }
					</ExternalLink>
				</CardBody>
			</Card>
		</>
	);
}
